import { extend } from 'vee-validate';

extend('student_password', {
  validate: (value) => {
    return {
      required: true,
      // Least 4 characters, include alphabets and numeric only, but least 1 alphabet and 1 numeric
      valid: /^(?=.*?[a-zA-Z])(?=.*?\d)[a-zA-Z0-9]{4,}$/.test(value),
    };
  },
  computesRequired: true,
});
